import { db2025, db2026 } from "./firebase";
import { teams as teams2026 } from "../data/teams";
import { teams as teams2025 } from "../data/teams2025";
import { createTeamMappingService } from "../utils/teamMapping";
import ar2026Flyer from "../assets/images/ar2026_flyer.jpg";
import ar2025Flyer from "../assets/images/ar_golf_details.jpeg";

export const TOURNAMENT_CONFIGS = {
  "2026": {
    year: "2026",
    label: "AR 2026",
    db: db2026,
    teams: teams2026,
    emailDomain: "ar2026.golf",
    basePath: "",
    readOnly: false,
    poolOpen: false,
    poolMaxTeams: 5,
    poolFlyer: ar2026Flyer,
    venue: "Tarandowah & Fire Rock Golf Courses, Ohio",
    round1Course: "Tarandowah",
    round2Course: "Fire Rock",
    // 2026 tournament is over — lock all live scoring writes.
    round1ScoringLocked: true,
    round2ScoringEnabled: false,
  },
  "2025": {
    year: "2025",
    label: "AR 2025",
    db: db2025,
    teams: teams2025,
    emailDomain: "ar2025.golf",
    basePath: "/2025",
    readOnly: true,
    poolOpen: false,
    poolMaxTeams: 4,
    poolFlyer: ar2025Flyer,
    venue: "Turning Stone Resort Casino, Verona, NY",
    round1Course: "Kaluhyat",
    round2Course: "Atunyote",
  },
};

export const getTournamentConfig = (year) => TOURNAMENT_CONFIGS[year];

export const getTournamentConfigFromPath = (pathname) => {
  // Only the /2025 archive is closed/read-only. Everything else is live 2026.
  if (pathname === "/2025" || pathname.startsWith("/2025/")) {
    return TOURNAMENT_CONFIGS["2025"];
  }
  return TOURNAMENT_CONFIGS["2026"];
};

export const buildTournamentRuntime = (config) => ({
  ...config,
  teamMappingService: createTeamMappingService(
    config.teams,
    config.emailDomain
  ),
});
